import React, { useEffect, useState } from 'react'
import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Divider,
  Grid,
  Skeleton,
  Typography,
} from '@mui/material'
import { ArrowBack } from '@mui/icons-material'
import { Helmet } from 'react-helmet'
import { useNavigate, useParams } from 'react-router-dom'
import { useSnackbar } from 'notistack'
import { apiTenant } from '../../../services/Tenant/ApiTenant'
import TenantStatusBadge from '../../../components/Tenant/TenantStatusBadge'
import moment from 'moment'

const formatBRL = (centavos) => {
  return (centavos / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
}

const TenantChargeDetail = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const { enqueueSnackbar } = useSnackbar()
  const [charge, setCharge] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    apiTenant.get(`/tenant/charges/${id}/`)
      .then(response => {
        setCharge(response.data)
      })
      .catch(error => {
        console.error(error)
        enqueueSnackbar('Erro ao carregar cobrança.', { variant: 'error' })
      })
      .finally(() => {
        setLoading(false)
      })
  }, [id])

  if (loading) {
    return (
      <Container maxWidth={false}>
        <Box sx={{ marginY: '1em' }}>
          <Skeleton variant="rounded" height={300} animation="pulse"/>
        </Box>
      </Container>
    )
  }

  if (!charge) {
    return (
      <Container maxWidth={false}>
        <Box sx={{ marginY: '2em', textAlign: 'center' }}>
          <Typography variant="h6" color="text.secondary">Cobrança não encontrada.</Typography>
          <Button startIcon={<ArrowBack/>} onClick={() => navigate('/area-cliente/cobrancas/')} sx={{ mt: 2 }}>
            Voltar para cobranças
          </Button>
        </Box>
      </Container>
    )
  }

  return (
    <>
      <Helmet>
        <title>Cobrança {charge.number} - Portal do Cliente</title>
      </Helmet>
      <Container maxWidth={false}>
        <Box sx={{ marginY: '1em', pb: 1 }}>
          <Button startIcon={<ArrowBack/>} onClick={() => navigate('/area-cliente/cobrancas/')} sx={{ mb: 2 }}>
            Voltar para cobranças
          </Button>
        </Box>

        <Card>
          <CardContent>
            {/* Header */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 2 }}>
              <Box>
                <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
                  {charge.number}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Unidade {charge.unit_number}
                </Typography>
              </Box>
              <TenantStatusBadge status={charge.status}/>
            </Box>

            <Divider sx={{ my: 2 }}/>

            {/* Info Grid */}
            <Grid container spacing={3} sx={{ mb: 3 }}>
              <Grid item xs={12}>
                <Typography variant="body2" color="text.secondary">Descrição</Typography>
                <Typography variant="body1">
                  {charge.description}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={3}>
                <Typography variant="body2" color="text.secondary">Vencimento</Typography>
                <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                  {charge.due_date ? moment(charge.due_date).format('DD/MM/YYYY') : '-'}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={3}>
                <Typography variant="body2" color="text.secondary">Total</Typography>
                <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                  {formatBRL(charge.total)}
                </Typography>
              </Grid>
              {charge.paid_at && (
                <Grid item xs={6} sm={3}>
                  <Typography variant="body2" color="text.secondary">Pago em</Typography>
                  <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                    {moment(charge.paid_at).format('DD/MM/YYYY')}
                  </Typography>
                </Grid>
              )}
            </Grid>
          </CardContent>
        </Card>
      </Container>
    </>
  )
}

export default TenantChargeDetail
